import { createContext } from 'react';
import { defaultBaseZIndex } from './default';

export const zIndexContext = createContext<number>(defaultBaseZIndex);
